var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.selectedUser == null
      ? _c("div", { staticClass: "modal-card-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label", attrs: { for: "" } }, [
              _vm._v("Buscar usuario"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInput,
                    expression: "userInput",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", placeholder: "Escriba aquí" },
                domProps: { value: _vm.userInput },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.userInput = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v("Escriba el nombre o apellido del usuario"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [_vm._v(_vm._s(_vm.status))]),
            _vm._v(" "),
            _c(
              "table",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchResult.length > 0,
                    expression: "searchResult.length > 0",
                  },
                ],
                staticClass: "table is-bordered is-narrow is-marginless",
              },
              [
                _c(
                  "tbody",
                  _vm._l(_vm.searchResult, function (result) {
                    return _c("tr", { key: result.index }, [
                      _c("td", [
                        _c("i", { staticClass: "fas fa-user" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.selectUser(result)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(result.nombre) +
                                " " +
                                _vm._s(result.apellido)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.tieneRolLyris
                          ? _c("span", { staticClass: "disabled" }, [
                              _vm._v(
                                "organizacion_id: " +
                                  _vm._s(result.organizacion_id)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "modal-card-body" },
          [
            _c("b-message", { attrs: { type: "is-danger" } }, [
              _c("h1", { staticClass: "title is-4 has-text-danger" }, [
                _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                _vm._v(" Atención\r\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("p", [
                  _vm._v(
                    "\r\n            ¿Está seguro de ceder los permisos de propietario a "
                  ),
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        `${_vm.selectedUser.apellido.toUpperCase()}, ${
                          _vm.selectedUser.nombre
                        }`
                      )
                    ),
                  ]),
                  _vm._v("?\r\n          "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "De proceder con la transferencia, dejará de ser propietario del documento."
                  ),
                ]),
              ]),
            ]),
          ],
          1
        ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-foot is-justify-content-flex-end" }, [
      _c(
        "button",
        {
          staticClass: "button is-outlined is-dark",
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("\r\n        Cancelar")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            attrs: { disabled: _vm.selectedUser == null },
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-exchange-alt fa-fw" }),
            _vm._v(" Cambiar propietario"),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v("Cambiar propietario"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }